import { render } from "./AgeForm.vue?vue&type=template&id=47f35a3a"
import script from "./AgeForm.vue?vue&type=script&lang=js"
export * from "./AgeForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__